
/* -------------------------------------------------------------------------------- *\
|                               getversion
|   "x.x.x" is replaced by the git tag or the short commit sha in the CI build.
\* -------------------------------------------------------------------------------- */
export const getversion = (): string =>
{
    return "hpv2-simulator @mclloyd 2026 - version 2.3.2";
}
